export default __webpack_public_path__ + "ef29ce26df82551fe56dbd0de2eed6ce.png";